import React, { useState } from "react";
import { useGeneral } from "../../../../stores/useGeneral";
import { FiSmile } from "react-icons/fi";
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import clx from "classnames";

export const EmojiPicker = ({wrapper, right, emoji, direction}) => {
    const [status, setStatus] = useState(false);
    const {darkmode} = useGeneral(state=>state);
    return (
      <div className="relative group z-[100]">
         <div 
          onClick={()=>setStatus(!status)}
          >
            {wrapper}
            {!wrapper && (
              emoji ? emoji:  <FiSmile size={21} class="cursor-pointer stroke-gray-500" />
            )}
          </div>
          {status && (
            <div class={clx('absolute', direction ? direction: right?'top-8 right-0':'left-0 bottom-8' )}>
               <Picker data={data} onEmojiSelect={console.log} theme={darkmode} />
            </div>
          )}
      </div>
    )
  }


